import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useDialog } from '@/providers/DialogProvider';
import { Trash } from '@mynaui/icons-react';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { DeleteAccountDialog } from './dialogs/DeleteAccountDialog';

interface iLabelProps {
  title: string;
  description: string;
}
const Label: FunctionComponent<iLabelProps> = ({ title, description }) => {
  return (
    <div className='flex flex-col gap-1'>
      <h3 className='font-medium leading-none text-slate-900 dark:text-white'>{title}</h3>
      <p className='text-sm font-medium leading-none text-slate-500 dark:text-white/70'>{description}</p>
    </div>
  );
};
export const DangerZone: FunctionComponent<{ userId: string }> = ({ userId }) => {
  const { openDialog } = useDialog();
  const { t } = useTranslation('account');

  return (
    <Card className='border-rose-200'>
      <CardHeader className='border-rose-200 bg-rose-50/40'>
        <CardTitle className='text-rose-600'>{t('danger.title')}</CardTitle>
        <CardDescription className='text-rose-600/70'>{t('danger.description')}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className='flex items-center justify-between'>
          <Label title={t('danger.deleteAccount')} description={t('danger.deleteAccountDescription')} />
          <AlertDialog>
            <AlertDialogTrigger asChild>
              <Button variant='destructive'>
                <Trash className='h-4 w-4 mr-2 stroke-2' />
                {t('danger.deleteAccount')}
              </Button>
            </AlertDialogTrigger>
            <AlertDialogContent>
              <AlertDialogHeader>
                <AlertDialogTitle>{t('danger.confirmTitle')}</AlertDialogTitle>
                <AlertDialogDescription>
                  {t('danger.confirmDescription')}
                </AlertDialogDescription>
              </AlertDialogHeader>
              <AlertDialogFooter>
                <AlertDialogCancel>{t('danger.cancel')}</AlertDialogCancel>
                <AlertDialogAction
                  onClick={() => openDialog(<DeleteAccountDialog userId={userId} />)}
                  className='bg-red-600 hover:bg-red-700'>
                  {t('danger.deleteAccount')}
                </AlertDialogAction>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialog>
        </div>
      </CardContent>
    </Card>
  );
};
